import { PhotosClearAllPhotosReducer } from './types';

export const photosClearAllPhotosReducer: PhotosClearAllPhotosReducer = (
  state
) => {
  return {
    ...state,
    selectedPhotos: [],
    unverifiedPhotos: undefined,
    approvedPhotos: undefined,
  };
};
